// src/api/apiTermOfPayments.js
import axios from "../utils/axios";

/// Get Term of Payments
export const getAllTermOfPayments = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("term-of-payments", { params });
    return data;
};

/// Get Term of Payments Enum Values for Select Dropdown
export const getTermOfPaymentsEnumValues = async () => {
    try {
        const { data } = await axios.get("term-of-payments/enum-values");
        return data;
    } catch (error) {
        console.error("getTermOfPaymentsEnumValues error:", error);
        throw error;
    }
};

/// Get Term of Payments for Select Dropdown
export const getTermOfPaymentsForSelect = async () => {
    try {
        const { data } = await axios.get("term-of-payments/for-select");
        return data;
    } catch (error) {
        console.error("getTermOfPaymentsForSelect error:", error);
        throw error;
    }
};

/// Get Term of Payment
export const getTermOfPayment = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`term-of-payments/${id}`);
    return data;
};

/// Create Term of Payment
export const createTermOfPayment = async (req) => {
    try {
        const { data } = await axios.post("term-of-payments", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createTermOfPayment error:", error);
        throw error;
    }
};

/// Update Term of Payment
export const updateTermOfPayment = async (req, id) => {
    try {
        const { data } = await axios.put(`term-of-payments/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateTermOfPayment error:", error);
        throw error;
    }
};

/// Delete Term of Payment
export const deleteTermOfPayment = async (id) => {
    try {
        const { data } = await axios.delete(`term-of-payments/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteTermOfPayment error:", error);
        throw error;
    }
};

/// Delete All Term of Payments
export const deleteAllTermOfPayments = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "term-of-payments/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllTermOfPayments error:", error);
        throw error;
    }
};

/// Force Delete Term of Payment
export const forceDeleteTermOfPayment = async (id) => {
    try {
        const { data } = await axios.delete(`term-of-payments/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteTermOfPayment error:", error);
        throw error;
    }
};

/// Force Delete All Term of Payments
export const forceDeleteAllTermOfPayments = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "term-of-payments/mass-force-delete",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllTermOfPayments error:", error);
        throw error;
    }
};

/// Restore Term of Payment
export const restoreTermOfPayment = async (id) => {
    try {
        const { data } = await axios.post(`term-of-payments/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreTermOfPayment error:", error);
        throw error;
    }
};

/// Restore All Term of Payments
export const restoreAllTermOfPayments = async (ids = []) => {
    try {
        const { data } = await axios.post("term-of-payments/mass-restore", { items: ids }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAllTermOfPayments error:", error);
        throw error;
    }
};